import React from "react";
import { Table } from "reactstrap";
import NumberCommas from "../../../Components/NumberCommas/NumberCommas";
import { formatDate } from "../../../Components/FormatDate/FormatDate";

const PrintableTable = ({ supplierDetail }) => {
  return (
    <Table hover bordered className="print-table">
      <thead className="table-light">
        <tr>
          <th style={{ width: "60px" }}>S.N</th>
          <th style={{ width: "180px" }}>Transaction Date</th>
          <th style={{ width: "130px" }}>Invoice Number</th>
          <th style={{ width: "150px" }}>Sub Total</th>
          <th style={{ width: "150px" }}>Net Amount</th>
          <th>Remarks</th>
        </tr>
      </thead>
      <tbody>
        {supplierDetail.map((row, index) => (
          <tr key={row.id}>
            <td>{index + 1}</td>
            <td>{formatDate(row.valueData)}</td>
            <td>{row.invoiceNumber}</td>
            <td className="text-end">
              <NumberCommas number={row.subTotal} />
            </td>
            {/* <td className="text-end">
              <NumberCommas number={row.total} />
            </td> */}
            <td className="text-end">
              <NumberCommas number={row.netAmt} />
            </td>
            <td>{row.remarks || "-"}</td>
          </tr>
        ))}
      </tbody>
      <tfoot className="table-group-divider">
        <tr>
          <td colSpan="2" className="text-end fw-bold">
            Total
          </td>
          <td className="text-end fw-bold">
            <NumberCommas
              number={supplierDetail.reduce(
                (sum, row) => sum + row.subTotal,
                0
              )}
            />
          </td>
          <td className="text-end fw-bold">
            <NumberCommas
              number={supplierDetail.reduce((sum, row) => sum + row.total, 0)}
            />
          </td>
          <td className="text-end fw-bold">
            <NumberCommas
              number={supplierDetail.reduce((sum, row) => sum + row.netAmt, 0)}
            />
          </td>
          <td></td>
        </tr>
      </tfoot>
    </Table>
  );
};

export default PrintableTable;
